var React = require('react');

function Location (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M344 256a88 88 0 1 1-88-88 88 88 0 0 1 88 88z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M496 224h-50.88A191.86 191.86 0 0 0 288 66.88V16a16 16 0 0 0-16-16h-32a16 16 0 0 0-16 16v50.88A191.86 191.86 0 0 0 66.88 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h50.88A191.86 191.86 0 0 0 224 445.12V496a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-50.88A191.86 191.86 0 0 0 445.12 288H496a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM256 384a128 128 0 1 1 128-128 128 128 0 0 1-128 128z","className":"fa-primary","key":2})]);
}

Location.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Location;

Location.default = Location;
